import { useState } from 'react';
import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { readInviteToken } from '../../team/teamInviteToken';

/**
 * The workspace name of the team invite that opened the sign-in page (Ruling F2, design g7).
 * `TeamAcceptView` keeps the invite token for the sign-in round trip. The API reads the name from
 * that token (`team.inviteWorkspaceName`, no session). A name from the URL is never printed: anyone
 * can write a link. Null while the name loads, with no token, and for an invite that is not open:
 * the page then shows the headline with no name.
 */
export function useInviteWorkspaceName(enabled: boolean): string | null {
  const trpcAPI = useTRPCAPI();
  // The token of this page view. The storage is read one time.
  const [token] = useState(() => (enabled ? readInviteToken() : null));
  const { data } = useTRPCQuery(
    trpcAPI.team.inviteWorkspaceName.queryOptions(
      { token: token ?? '' },
      { enabled: enabled && token !== null, staleTime: Infinity, retry: false }
    )
  );
  const name = data?.workspaceName?.trim() ?? '';
  return name === '' ? null : name;
}
